import { useState, useCallback } from 'react'

interface AsyncState<T> {
  data: T | null
  error: Error | null
  isLoading: boolean
}

type AsyncFunction<T> = () => Promise<T>

export const useAsync = () => {
  const [asyncState, setAsyncState] = useState<AsyncState<unknown>>({
    data: null,
    error: null,
    isLoading: false,
  })

  const runAsync = useCallback(async (asyncFunction: AsyncFunction<unknown>) => {
    try {
      setAsyncState((prev) => ({ ...prev, isLoading: true }))
      const data = await asyncFunction()
      setAsyncState({ data, error: null, isLoading: false })
    } catch (error) {
      setAsyncState({ data: null, error: error as Error, isLoading: false })
    }
  }, [])

  return { ...asyncState, runAsync }
}
